import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGS } from "@/i18n";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher({ variant = "ghost" }) {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    if (user && user.role === "client") {
      api.put("/profile/lang", { lang: code }).catch(() => {});
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="lang-switcher"
          className={`flex items-center gap-1.5 rounded-lg px-2.5 py-2 text-sm font-medium transition-colors ${variant === "solid" ? "text-slate-700 hover:bg-slate-100" : "text-slate-600 hover:bg-slate-100"}`}>
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{current.flag} {current.label}</span>
          <span className="sm:hidden">{current.flag}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" data-testid="lang-menu">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => change(l.code)} data-testid={`lang-option-${l.code}`}
            className="flex items-center gap-2 cursor-pointer">
            <span>{l.flag}</span> <span className="flex-1">{l.label}</span>
            {l.code === i18n.language && <Check className="h-4 w-4 text-blue-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
